import styles from './TermsConditions.module.css';

function TermsConditions({ ...props }) {
  return (
    <>
      <p className={`${styles.container} bodySmReg textCenter `}>
        By placing your order you agree to our{' '}
        <a
          className="linkBorderBottom"
          href={`${process.env.REACT_APP_HOME_URL}/terms`}
          target="_blank"
          rel="noreferrer"
        >
          Terms & Conditions
        </a>{' '}
        and{' '}
        <a
          className="linkBorderBottom"
          href={`${process.env.REACT_APP_HOME_URL}/privacy`}
          target="_blank"
          rel="noreferrer"
        >
          Privacy Policy.
        </a>
      </p>
    </>
  );
}

export default TermsConditions;
